<template>
  <div class="container">
    <div class="info">
      <div class="title">Станьте заметнее для путешественников</div>
      <div class="subtitle">
        Поделитесь интересным фактом про достопримечательность — это покажет вашу экспертность и привлечёт внимание к
        экскурсиям
      </div>
      <UiButtonV3
        :variant="UiButtonVariant.PRIMARY"
        :color-mode="UiButtonColorMode.NEUTRAL"
        :size="UiButtonSize.S"
        text="Поделиться фактом"
        class="btn"
        data-test="more-guide-spreadsheet"
        @clicked="goTo"
      />
    </div>
    <GuideMessageInfo :comment="guideInfo" />
  </div>
</template>

<script setup lang="ts">
  import { UiButtonV3, UiButtonColorMode, UiButtonVariant, UiButtonSize } from '@experience/vue3-kit';

  import type { SightGuideComment, SightModalSight } from '@/shared/types/sight-modal';
  import GuideMessageInfo from '@/shared/ui/sights/GuideMessageInfo.vue';

  const props = defineProps<{
    guideInfo: SightGuideComment;
    sight: SightModalSight;
  }>();

  const goTo = () => {
    const guideId = props.guideInfo.guide?.id;
    const sightId = props.sight.id;

    window.open(
      `https://docs.google.com/forms/d/e/1FAIpQLSftkvScsSbJ66TONCjgOBebYPUM8bhprXGSL7mElEQOM1PKrQ/viewform?usp=pp_url&entry.1804679933=${String(guideId ?? '')}&entry.583654716=${String(sightId)}`,
      '_blank',
    );
  };
</script>

<style lang="scss" scoped>
  .container {
    padding: var(--alias-space-4) var(--alias-space-4) var(--alias-space-12) var(--alias-space-4);
    background-color: var(--alias-color-background-subtle);
    border-radius: var(--alias-radius-16);
  }

  .info {
    padding: var(--alias-space-8);
    background-color: var(--alias-color-background-default);
    border-radius: var(--alias-radius-12);
  }

  .title {
    @include base-400-300-semi;

    @include tablet {
      max-width: 320px;
    }
  }

  .subtitle {
    max-width: 480px;
    margin-top: var(--alias-space-4);

    @include base-300-300-regular;
  }

  .btn {
    margin-top: var(--alias-space-8);
  }

  .info + :deep(.guide-info) {
    padding: 0 12px;
  }
</style>
